import { SvgList } from "icons/SvgList"
import { LayoutStore } from "store/layout-store"


export const Container = ({ children }: any) => {
    const {setDisplayNavMobile } = LayoutStore()

    return (
        <>
            <div className='lg:w-[calc(100%-256px)] w-full min-h-screen flex flex-col'>
                <div className="w-full h-[80px] bg-trade-50 flex items-center justify-between px-3">
                    <button onClick={()=>{setDisplayNavMobile(true)}} className="w-[35px] h-[35px] flex items-center justify-center">
                        <SvgList className="w-[30px] fill-gray-400 lg:hidden block" />
                    </button>
                </div>
                <div className="w-full min-h-screen bg-trade-25 md:rounded-tr-3xl rounded-tr-[0] pb-4">
                    {children}
                </div>
            </div>
        </>
    )
}